import { z } from "zod";

export const MethodCalculationSchema = z.object({
  id: z.number().positive().min(1),
  flowTestId: z.number().positive().min(1),
  inputId: z.number().positive().min(1),
  method: z.string(),
  inputParameters: z.record(z.any()),
  results: z.record(z.any()),
  createdOn: z.date(),
  modifiedOn: z.date(),
  createdBy: z.number().positive().min(1),
  modifiedBy: z.number().positive().min(1),
  active: z.boolean(),
});

export type MethodCalculation = z.infer<typeof MethodCalculationSchema>;
